import store from '../../store'
import { heightConfig } from '../params/global'
// 主表高度方法
export function mainHeightComputed(subVal = 0) {
  return (
    Number(store.state.clientHeight) -
    Number(subVal) -
    Number(heightConfig.homeHeaderHeight) -
    Number(heightConfig.navHeaderHeight) +
    'px'
  )
}

/**
 * 计算表格高度
 * @param {Number} customHeight 需要减去的自定义高度
 * @param {Boolean} isSearchForm 是否要减去查询框
 * @param {Boolean} isToolBar 是否要减去工具栏
 * @returns
 */
export function tableHeightComputed(
  customHeight = 0,
  isSearchForm = false,
  isToolBar = false
) {
  let searchHeight = isSearchForm ? Number(heightConfig.searchFormHeight) : 0
  let toolBarHeight = isToolBar ? Number(heightConfig.toolBarHeight) : 0
  return (
    Number(store.state.clientHeight) -
    Number(customHeight) -
    searchHeight -
    toolBarHeight -
    Number(heightConfig.homeHeaderHeight) +
    'px'
  )
}
